// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// init Swiper:
let i = 0;
document.querySelectorAll('.banner-swiper').forEach(el => {
  i++;
// init Swiper:
  let next = el.parentElement.querySelector('.swiper-button-next');
  let prev = el.parentElement.querySelector('.swiper-button-prev');
  el.classList.add('banner-swiper-' + i);
  next.classList.add('banner-btn-next-' + i);
  prev.classList.add('banner-btn-prev-' + i);

  let swiper = new Swiper('.banner-swiper-' + i, {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    // Optional parameters
    // Responsive breakpoints

    breakpoints: {
      // when window width is >= 576px
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
    },

    loop: false,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.banner-btn-next-' + i,
      prevEl: '.banner-btn-prev-' + i,
    }
  })
})
